import React from 'react';
import SelectPill from '../../../../../../components/SelectPill';
import { RetailProductSelect } from '../FilterSelects/RetailProductSelect';
import arrowRightIcon from '../../../../../../assets/icons/icon_arrow-right-gray.svg';
import styles from './RetailFilterSelection.module.scss';

type ScopeKey = 'categoria' | 'secao';

type ScopeListEntry = {
  lista: { label: string; value: string }[];
  value: string[];
  cache: unknown[];
};

type RetailFilterSelectionProps = {
  productsCompetitor: any;
  selectedScopeType: string;
  onSelectScopeType: (value: string) => void;
  scopeListData: Record<ScopeKey, ScopeListEntry>;
  onSelectProductFilter: (value: any, item: any) => void;
  onSearchProductFilter: (value: any, type: string) => void;
  onCleanProductFilter: () => void;
  onOpenProductFilter: (value: any, type: string) => void;
  onClickLoadMoreProducts: () => void;
  onCheckAllProductsProducts: () => void;
  indeterminateProductCompetitor: boolean;
  allProductsCompetitorChecked: boolean;
  onSearchScopeItem: (value: string, scopeKey: ScopeKey) => void;
  onOpenScopeItem: (scopeKey: ScopeKey) => void;
  onSelectScopeItem: (scopeKey: ScopeKey, value: string[]) => void;
  onCleanScopeItem: (scopeKey: ScopeKey) => void;
};

// "Todo o sortimento" fica de fora por enquanto: o enum TipoComparacao do backend só aceita
// PRODUTO/CATEGORIA/SECAO. Reintroduzir quando o backend suportar.
const SELECTION_DATA = [
  { label: 'Produto', value: 'product' },
  { label: 'Categoria', value: 'category' },
  { label: 'Seção', value: 'section' },
];

const SCOPE_KEY_BY_SELECTION: Record<string, ScopeKey> = {
  category: 'categoria',
  section: 'secao',
};

const SCOPE_PLACEHOLDER_BY_SELECTION: Record<string, string> = {
  category: 'Escolha até 10 categorias',
  section: 'Escolha até 10 seções',
};

export const RetailFilterSelection = ({
  productsCompetitor,
  selectedScopeType,
  onSelectScopeType,
  scopeListData,
  onSelectProductFilter,
  onSearchProductFilter,
  onCleanProductFilter,
  onOpenProductFilter,
  onClickLoadMoreProducts,
  onCheckAllProductsProducts,
  indeterminateProductCompetitor,
  allProductsCompetitorChecked,
  onSearchScopeItem,
  onOpenScopeItem,
  onSelectScopeItem,
  onCleanScopeItem,
}: RetailFilterSelectionProps) => {
  const scopeKey = SCOPE_KEY_BY_SELECTION[selectedScopeType];
  const scopeData = scopeKey ? scopeListData[scopeKey] : null;

  return (
    <div className={styles['retail-filter-selection-wrapper']}>
      <SelectPill
        id="select-picker-pill"
        placeholder="Escolha uma opção"
        name="filter"
        cleanable={false}
        searchable={false}
        value={selectedScopeType}
        data={SELECTION_DATA}
        onSelect={onSelectScopeType}
      />
      <img src={arrowRightIcon} alt="" className={styles['arrow-right-icon']} />
      {selectedScopeType === 'product' && (
        <RetailProductSelect
          placeholder="Produto"
          products={productsCompetitor}
          onSelect={(value, item) => onSelectProductFilter(value, item)}
          onSearch={value => onSearchProductFilter(value, 'competitor')}
          onClean={onCleanProductFilter}
          onOpen={() => onOpenProductFilter(null, 'competitor')}
          competitionType="varejo"
          onClickLoadMore={onClickLoadMoreProducts}
          onCheckAllProducts={onCheckAllProductsProducts}
          productsCheckAllStatus={indeterminateProductCompetitor}
          isAllProductsChecked={allProductsCompetitorChecked}
        />
      )}
      {scopeKey && scopeData && (
        <SelectPill
          id="check-picker-pill"
          type="check"
          placeholder={SCOPE_PLACEHOLDER_BY_SELECTION[selectedScopeType]}
          name="filter"
          cleanable
          value={scopeData.value}
          data={scopeData.lista}
          onSearch={value => onSearchScopeItem(value, scopeKey)}
          onOpen={() => onOpenScopeItem(scopeKey)}
          onSelect={value => onSelectScopeItem(scopeKey, value)}
          onClean={() => onCleanScopeItem(scopeKey)}
          locale={{
            noResultsText: 'Nenhum item encontrado',
            searchPlaceholder: 'Buscar item',
          }}
        />
      )}
    </div>
  );
};
